import React, { useEffect, useState } from 'react';
import { Col, Form } from 'react-bootstrap';
import { FieldArray, ErrorMessage } from 'formik';

const PPEField = ({ relativeFieldValue, index, values, setFieldValue }) => {
  const [editingIndex, setEditingIndex] = useState(null); // To track which PPE badge is being edited
  const [editingValue, setEditingValue] = useState('');   // To store the current editing value
  const [defaultValue, setDefaultValue] = useState('NA');
  useEffect(()=>{
    if (relativeFieldValue && relativeFieldValue.length == 0) {
      setFieldValue(`forms[${index}].ppe`, "");
    }
  },[relativeFieldValue, index, setFieldValue])
  return (
    <Col>
      <Form.Group>
        <Form.Label>PPE</Form.Label>
        <FieldArray
          name={`forms[${index}].ppe`}
          render={(arrayHelpers) => (
            <>
              <div className="form-control" style={{ display: 'flex', flexWrap: 'wrap', height: "auto" }}>
                {values.forms[index].ppe && values.forms[index].ppe.length > 0 ? (
                  values.forms[index].ppe.map((ppeItem, ppeIndex) => (
                    <React.Fragment key={ppeIndex}>
                      {editingIndex === ppeIndex ? (
                        // If in edit mode, render an input field
                        <Form.Control
                          type="text"
                          value={editingValue}
                          onChange={(e) => setEditingValue(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              // Save the edited value on pressing Enter
                              const updatedPPE = [...values.forms[index].ppe];
                              updatedPPE[ppeIndex] = editingValue || "NA";
                              setFieldValue(`forms[${index}].ppe`, updatedPPE);
                              setEditingIndex(null); // Exit editing mode
                              e.preventDefault();
                            }
                          }}
                          onBlur={() => {
                            // Save changes when clicking outside
                            const updatedPPE = [...values.forms[index].ppe];
                            updatedPPE[ppeIndex] = editingValue || "NA";
                            setFieldValue(`forms[${index}].ppe`, updatedPPE);
                            setEditingIndex(null); // Exit edit mode
                          }}
                          autoFocus
                        />
                      ) : (
                        // If not in edit mode, render the badge with ellipsis overflow
                        <span
                          className="mr-2"
                          onClick={() => {
                            setEditingIndex(ppeIndex); // Enter edit mode
                            setEditingValue(ppeItem);  // Load current value
                          }}
                          style={{
                            cursor: 'pointer',
                            backgroundColor: "#e6e6e6",
                            color: "black",
                            borderRadius: "2px",
                            margin: "2px",
                            padding: "3px 6px",
                            fontSize: "85%",
                            maxWidth: "100px", // Adjust max width to control overflow
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            display: 'inline-block',
                            verticalAlign: 'middle',
                          }}
                        >
                          {ppeItem}
                        </span>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <div>No PPE added yet.</div>
                )}
              </div>
              <ErrorMessage
                name={`forms[${index}].ppe`}
                component="div"
                className="text-danger"
              />
            </>
          )}
        />
      </Form.Group>
    </Col>
  );
};

export default PPEField;
